import { range } from 'lodash-es'

import type { FormWizardV2Step } from './types'

export function isStepDisabled<T extends string>(step: FormWizardV2Step<T>) {
  return step.disabled === 'hidden' || step.disabled === true
}

/**
 * @deprecated: Please do not use this function.
 * Set `disabled` prop in the wizard instead.
 */
export const skipToStep = <T extends string>({
  steps,
  currentSlug,
  skipToSlug,
  toggleSkip,
}: {
  steps: FormWizardV2Step<T>[]
  currentSlug: T
  skipToSlug: T
  toggleSkip: boolean
}) => {
  const currentIndex = steps.findIndex(step => step.slug === currentSlug)
  const skipToIndex = steps.findIndex(step => step.slug === skipToSlug)
  range(currentIndex + 1, skipToIndex).forEach(i => {
    steps[i].disabled = toggleSkip
  })
}
